module.exports = __webpack_public_path__ + "img/pc-banner.c9313542.png";